export function AdSlot({ className = "" }) {
  return (
    <div
      data-testid="ad-slot"
      className={`relative flex items-center justify-center border-2 border-dashed border-border bg-surface overflow-hidden ${className}`}
      style={{
        backgroundImage:
          "repeating-linear-gradient(45deg, hsl(var(--border) / 0.35) 0, hsl(var(--border) / 0.35) 1px, transparent 1px, transparent 12px)",
      }}
      aria-label="Advertisement placeholder"
    >
      <span className="text-xs uppercase tracking-[0.3em] text-muted-foreground bg-background px-3 py-1 border border-border">
        Ad Space
      </span>
    </div>
  );
}
